import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import tiLogoSmall from '../../../assets/images/TheInformationLogo.png';

import { Comment as CommentType } from '../../utils/backend-api/comments';
import UserProfileLink from '../User/UserProfileLink';
import { userName, userTitle } from '../User/userHelpers';
import TimeAgo from '../shared/TimeAgo';
import CommentAvatar from './CommentAvatar';

export default function CommentContent({ comment }: { comment: CommentType }) {
  const { user } = comment;
  return (
    <div className="comment-content">
      <div className="comment-header">
        <CommentAvatar user={user} className="block sm:hidden" />
        <div className="comment-author">
          <>
            <div className="comment-author-name">
              <UserProfileLink user={user} linkClassName="quiet-link">
                {userName(user)}
              </UserProfileLink>
              {comment.user.staff && !comment.promoted && (
                <img src={tiLogoSmall} className="comment-staff-logo" />
              )}
            </div>
            <div className="comment-author-title">{userTitle(user)}</div>
          </>
        </div>
        <div className="comment-header-right">
          {comment.promoted && (
            <div>
              <div className="promoted-badge">
                <span className="fa fa-star" />
                <span className="promoted-text">Promoted</span>
                <span className="tooltip">
                  Our staff has promoted this comment because it is great!
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="comment-body">{ReactHtmlParser(comment.body)}</div>

      {!!comment.edited_at && (
        <div className="comment-edited">
          Edited <TimeAgo date={comment.edited_at} />
        </div>
      )}
    </div>
  );
}
